var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M261.5 481C141.93 481 45 383.398 45 263S141.93 45 261.5 45 478 142.602 478 263s-96.93 218-216.5 218z","stroke":"#F5F6F7","strokeWidth":"90","fill":"none","opacity":".675"}));
}

Circle.defaultProps = {"width":"523","height":"526"};

module.exports = Circle;

Circle.default = Circle;
